import { useState } from "react";
import { FileText, GraduationCap } from "lucide-react";

import Header from "../components/Header";
import StudentFacilitatorGuide from "../components/guides/StudentFacilitatorGuide";
import TeacherFacilitatorGuide from "../components/guides/TeacherFacilitatorGuide";

export const Guides = () => {
    const [selectedGuide, setSelectedGuide] = useState("student");

    const guideOptions = [
        {
            id: "student",
            label: "Student",
            icon: FileText,
            disabled: false,
        },
        {
            id: "teacher",
            label: "Teacher / Counselor",
            icon: GraduationCap,
            disabled: false,
        },
    ];

    return (
        <div className="min-h-screen bg-[#f8f4ea] text-black">
            <Header />

            <main className="relative overflow-hidden border-t-[4px] border-black">
                {/* Background texture/pattern */}
                <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.08)_1px,transparent_1px)] [background-size:14px_14px] opacity-70" />

                <div
                    className="absolute left-0 top-0 h-[620px] w-full bg-cover bg-center opacity-80"
                    style={{
                        backgroundImage: "url('/assets/HeroBackground.png')",
                    }}
                />

                <div
                    className="absolute bottom-0 right-0 h-[520px] w-full bg-cover bg-center opacity-10"
                    style={{
                        backgroundImage: "url('/assets/HeroBackground.png')",
                    }}
                />

                <section className="relative mx-auto max-w-5xl px-6 pb-12 pt-20 md:pb-16 md:pt-24 lg:px-8">
                    {/* Guide Selector */}
                    <div className="mx-auto mb-10 max-w-2xl rounded-[24px] border-[4px] border-black bg-white p-4 shadow-[7px_7px_0_#000]">
                        <p className="mb-3 text-center text-xs font-black uppercase tracking-wide text-red-500">
                            Choose a Facilitator Guide
                        </p>

                        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
                            {guideOptions.map((option) => {
                                const Icon = option.icon;
                                const isSelected = selectedGuide === option.id;

                                return (
                                    <div key={option.id} className="group relative">
                                        <button
                                            type="button"
                                            disabled={option.disabled}
                                            onClick={() => {
                                                if (!option.disabled) {
                                                    setSelectedGuide(option.id);
                                                }
                                            }}
                                            className={`
                                                inline-flex min-w-[180px] items-center justify-center gap-2 rounded-[14px]
                                                border-[3px] border-black px-5 py-3 text-sm font-black uppercase md:text-base
                                                transition

                                                ${
                                                    option.disabled
                                                        ? "cursor-not-allowed bg-gray-200 text-black/40 shadow-[3px_3px_0_#000]"
                                                        : isSelected
                                                            ? "translate-x-[2px] translate-y-[2px] bg-[#ffbc00] shadow-[2px_2px_0_#000]"
                                                            : "bg-[#f8f4ea] shadow-[5px_5px_0_#000] hover:-translate-y-1 hover:shadow-[7px_7px_0_#000]"
                                                }
                                            `}
                                        >
                                            <Icon size={20} strokeWidth={3} />
                                            {option.label}
                                        </button>

                                        {option.disabled && (
                                            <div className="pointer-events-none absolute left-1/2 top-full z-10 mt-2 -translate-x-1/2 opacity-0 transition group-hover:opacity-100">
                                                <div className="whitespace-nowrap rounded-md border-[2px] border-black bg-black px-3 py-1 text-xs font-black uppercase text-white shadow-[3px_3px_0_#000]">
                                                    Coming Soon
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {selectedGuide === "student" && <StudentFacilitatorGuide />}
                    {selectedGuide === "teacher" && <TeacherFacilitatorGuide />}
                </section>
            </main>
        </div>
    );
};

export default Guides;